<ng-container *ngIf="showCamera && userHasAccess && videoStreamAvailable">
    <mat-card>
        <mat-card-content>
            <div class="container">
                <img src="{{ getCameraFeedUrl() }}" alt="camera" />
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
